import React, { useState } from 'react';
import { LoisirsGerer } from './LoisirsGerer';
import { LoisirsAnalytics } from './LoisirsAnalytics';
import { LoisirsConfigurer } from './LoisirsConfigurer';
import { useLanguage } from '../contexts/LanguageContext';
import { useScreenInit } from '../useScreenInit.js';
type SubTab = 'gerer' | 'analytiques' | 'configurer';
export function LoisirsModule() {
  const screenInit = useScreenInit();
  const {
    t
  } = useLanguage();
  const [activeSubTab, setActiveSubTab] = useState<SubTab>(screenInit.activeSubTab ?? 'gerer');
  const tabs: {
    id: SubTab;
    label: string;
  }[] = [{
    id: 'gerer',
    label: t('Gérer', 'Manage')
  }, {
    id: 'analytiques',
    label: t('Analytiques', 'Analytics')
  }, {
    id: 'configurer',
    label: t('Configurer', 'Configure')
  }];
  return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-3615" data-mp="2qanwhengond4">
      <div className="mb-8" data-id="element-3616" data-mp="2q8b6ce7jv6oz">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6" data-id="element-3617" data-mp="2v0ulhflvy9vw">
          <h1 className="text-2xl font-bold text-[#0F172A] font-heading" data-id="element-3618" data-mp="f9w4oehsx2u6">
            {activeSubTab === 'analytiques' ? t('Loisirs Analytics', 'Recreation Analytics') : t('Loisirs', 'Recreation')}
          </h1>
          <nav aria-label={t('Sections du module', 'Module sections')} className="flex items-center gap-2" data-id="element-3619" data-mp="p0qs3m6sa8h7">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveSubTab(tab.id)} className={`px-4 py-2 text-sm font-semibold rounded-lg transition-colors ${activeSubTab === tab.id ? 'text-white bg-[#0F172A] shadow-sm hover:bg-[#1E293B]' : 'text-slate-600 bg-white border border-slate-200 hover:bg-slate-50 hover:text-slate-900'}`} data-id="element-3620" data-mp="xzubysdryrwr">
                {tab.label}
              </button>)}
          </nav>
        </div>
      </div>

      {activeSubTab === 'analytiques' ? <LoisirsAnalytics data-id="element-3621" data-mp="3ugk46e00xfd9" /> : activeSubTab === 'configurer' ? <LoisirsConfigurer data-id="element-3622" data-mp="2awnoxstqigw" /> : <LoisirsGerer data-id="element-3623" data-mp="2byb81r10xfi" />}
    </div>;
}